<form [formGroup]="form">
  <avs-li-location-options
    type="building"
    (changed)="$event && patchForm('locationId', $event.locationId!)"
    [allRequired]="false"
    [config]="{ locationId: config()?.locationId }"
  />

  @if (form.get('locationId')?.value; as locationId) {
    <div class="flex flex-row">
      <label class="input-main-label capitalize">
        Data type *
      </label>
      <mat-form-field
        class="select-classic has-validation flex-1"
        appearance="outline"
      >
        <mat-select
          (valueChange)="createDisplayOptions($event)"
          [value]="form.get('dataType')?.value"
          panelClass="single-select-overlay"
          placeholder="Select type"
        >
          @for (type of dataTypes; track type) {
            <mat-option [value]="type.value">
              {{ type.title | titlecase }}
            </mat-option>
          }
        </mat-select>
        <mat-icon
          class="arrow-down"
          matSuffix
        >
          keyboard_arrow_down
        </mat-icon>
        <mat-error>Input is not valid</mat-error>
      </mat-form-field>
    </div>

    @if (form.get('dataType')?.value) {
      <div class="flex flex-row">
        <label class="input-main-label capitalize">
          Devices *
        </label>

        <avs-li-device-selector
          class="flex-1"
          (changed)="patchForm('deviceId', $event); patchForm('datapointName', '')"
          [filters]="{
            dataPoint: form.value?.dataType,
            location: form.value?.locationId
          }"
          [value]="form.get('deviceId')?.value"
        />
      </div>
    }

    @if (form.get('deviceId')?.value) {
      <div class="flex flex-row">
        <label class="input-main-label capitalize">
          Data Point *
        </label>
        <avs-li-data-point-selector
          class="flex-1"
          (changed)="patchForm('datapointName',$event)"
          [deviceId]="form.get('deviceId')?.value"
          [locationId]="locationId"
          [textFilter]="form.value?.dataType"
          [value]="form.get('datapointName')?.value"
        />
      </div>

      @if (form.get('datapointName')?.value) {
        <div class="flex flex-row">
          <label class="input-main-label capitalize">
            Period *
          </label>
          <avs-date-picker
            class="flex-1"
            (changedId)="patchForm('dateRange', $event)"
            [config]="{
              customRange: false,
            }"
            [value]="form.get('dateRange')?.value"
          />
        </div>

        <div
          class="flex mb-3"
          formGroupName="displayOptions"
        >
          <label class="input-main-label capitalize pt-2">
            Displayed parameters
          </label>
          <div class="flex-1 grid grid-cols-2">
            @for (option of selectedOptionList; track option) {
              <div>
                <label class="input-main-label capitalize flex items-center">
                  <mat-checkbox
                    (change)="changed.emit(form.valid ? form.value : null)"
                    [formControlName]="option"
                  />
                  {{ option | titlecase }}
                </label>
              </div>
            }
          </div>
        </div>
      }
    }
  }
</form>
